import React from 'react';
import { Icon } from '@vectord/components';

import styles from './MenteeDetails.module.scss';

function MenteeDetails({ user, superBatch }) {
  const { email, name } = user;
  const { name: superBatchName } = superBatch;

  return (
    <div className={styles.root}>
      <div className={styles.circle}>
        <Icon
          name="person"
          className="primary h1 text-c"
        />
      </div>
      <div className="column m-l-xs">
        <div className="bold h3 dark">{name}</div>
        <span>
          <span className="m-r-xs">{superBatchName}</span>
          <span>{email}</span>
        </span>
      </div>
    </div>
  );
}

export default MenteeDetails;
